import { render } from "./product-grid.vue?vue&type=template&id=024c95c8"
import script from "./product-grid.vue?vue&type=script&lang=js"
export * from "./product-grid.vue?vue&type=script&lang=js"

import "./product-grid.vue?vue&type=style&index=0&id=024c95c8&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__